import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  EnvironmentResponse,
  Error,
  GetAgentQuery,
  GetAgentsParams
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  params?: GetAgentsParams | GetAgentQuery
  shortErrorMessage?: string
  children?: (environment: EnvironmentResponse[]) => ReactElement
  onSuccess?: (data: EnvironmentResponse[]) => void
  onError?: (error: Error) => void
}

const GetAiEnvironmentsRequest = ({
  params,
  shortErrorMessage,
  children,
  onSuccess,
  onError
}: Props) => {
  const url = `${AI_API_SERVICE}/agents`

  const { requestParams } = useGetParamsWithSpaceId<GetAgentsParams | GetAgentQuery | undefined>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetAiEnvironmentsRequest
